/**
 * Targeting Rule Validation
 * 
 * Client-side validation helpers that call backend validation API
 */

import type { TargetingRuleV1, ValidationResult } from "./types";

/**
 * Validate targeting rule via backend API
 */
export async function validateTargetingRule(
  rule: TargetingRuleV1
): Promise<ValidationResult> {
  try {
    // Get Shopify session token (for admin API authentication)
    const token = await (window as any).getShopifySessionToken?.();

    const response = await fetch("/api/admin/targeting/validate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ rule }),
    });

    if (!response.ok) {
      throw new Error(`Validation request failed: ${response.statusText}`);
    }

    const result: ValidationResult = await response.json();
    return result;
  } catch (error) {
    console.error("Validation error:", error);
    return {
      valid: false,
      errors: [
        {
          path: "rule",
          message: error instanceof Error ? error.message : "Validation failed",
          code: "VALIDATION_ERROR",
        },
      ],
    };
  }
}
